module.exports = __webpack_public_path__ + "static/lightMode-bc502937c1ba9b466ebcb79c2c554ff2.wav";